import { createFileRoute } from '@tanstack/react-router'
import { FleetAnalysis } from 'pages/fleetAnalysis/FleetAnalysis'
import { fleetAnalysisSearchParams } from 'routes/fleet-analysis/-searchParams'

const RouteComponent = () => {
  const searchParams = Route.useSearch()

  return (
    <FleetAnalysis allSearchParams={searchParams} orgId={searchParams.orgId} />
  )
}

export const Route = createFileRoute('/fleet-analysis/')({
  component: RouteComponent,
  validateSearch: fleetAnalysisSearchParams,
  staticData: {
    layout: {
      enableScrolling: true,
    },
  },
})
